export class PaymentProfileEdit
{
      AnetProfileID: string;
      AnetPaymentProfileID: string;
      CustomerID: string;
      UserID: string;
      isTest: boolean;
}